// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'molaya-57735',
    appId: '1:1072793496635:web:137a6062495cdef007001e',
    storageBucket: 'molaya-57735.appspot.com',
    apiKey: 'AIzaSyBRj0OZWhKwOpHJvlfNUrcySk53rNk-mmw',
    authDomain: 'molaya-57735.firebaseapp.com',
    messagingSenderId: '1072793496635',
    measurementId: 'G-45XGNW7CVJ',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
